<div
  class="dynamic-field form-product-selection"
  [ngClass]="{
    'form-product-selection--has-btn': showButton,
    'dynamic-field--required': isRequired,
    'form-product-selection--rtl': rtl
  }"
  [formGroup]="group"
>
  <div class="control-wrap">
    <div class="sel-container">
      <cwc-picker
        (cwcChange)="waitUntilLoadData($event)"
        [label]="config.label | translate"
        [placeholder]="config.label | translate"
        [filter]="config.showSearch"
        [formControl]="this.group.controls['productSelect']"
        [attr.data-test]="config?.dataTId"
        [attr.data-tid]="config?.dataTId"
        [attr.data-name]="config?.name"
        (cwcFilter)="onSearch($event)"
        [filterPlaceholder]="'views.location.placeholder.search' | translate"
        formControlName="{{ config.name }}"
        [status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : 'regular'"
        [statusMessage]="formControlMessageError.getMessage(fieldControl)"
        [required]="fieldControl.hasError('required')"
        designVersion="v2"
      >
        <cwc-picker-option *ngFor="let option of options$ | async" [value]="option.id" designVersion="v2">
          {{ option.name }}
        </cwc-picker-option>
      </cwc-picker>
    </div>
  </div>
</div>
<div class="btn-container">
  <cwc-button *ngIf="showButton" (click)="openDialog()" designVersion="v2">{{ config.btnText | translate }}</cwc-button>
</div>
